import { useContext, useEffect, useRef, useState } from "react";
import fullHorizontal from "../../assets/icons/full-horizontal-divider.svg";
import partialHorizontal from "../../assets/icons/partial-horizontal-divider.svg";
import fullVertical from "../../assets/icons/full-vertical-divider.svg";
import partialVertical from "../../assets/icons/partial-vertical-divider.svg";
import removeDivider from "../../assets/icons/remove-divider.svg";
import dividerCutout from "../../assets/icons/divider-cutout.svg";
import knifeBlock from "../../assets/icons/add-knife-block.svg";
import spiceRack from "../../assets/icons/add-spice-rack.svg";
import removeKnifeBlock from "../../assets/icons/remove-knife-block.svg";
import removeSpiceRack from "../../assets/icons/remove-spice-rack.svg";
import removeCutout from "../../assets/icons/remove-cutout.svg";
import spaceEvenly from "../../assets/icons/space-evenly-vertical.svg";
import deleteAll from "../../assets/icons/delete-all.svg";
import ReactTooltip from "react-tooltip";
import tooltips from "../../content/tooltips.json";
import AppContext from "../../context";
import { readableColor } from "color2k";
import variables from "../../styles/export.module.scss";

const Toolbar = () => {
  const [toolActive, setToolActive] = useState(null);
  const validToolClickRef = useRef(null);
  const {
    disableAllTools,
    showTooltips,
    handleSetGlobalModal,
    triggerPriceUpdate,
  } = useContext(AppContext);

  const disabledToolTooltip =
    "You have an active tool. Click the selected tool on the divider or cancel it!";

  const dividerTools = [
    {
      disabled: disableAllTools || false,
      name: "Full Vertical Divider",
      id: "full-vertical-divider",
      action: () => {
        window?.positionNewFullVert?.();
      },
      secondaryAction: null,
      cancelAction: () => {
        window?.cancelPositionNewFullVert?.();
      },
      icon: fullVertical,
      tooltip: tooltips.fullVerticalDivider,
      disabledToolTooltip,
    },
    {
      disabled: disableAllTools || false,
      name: "Partial Vertical Divider",
      id: "partial-vertical-divider",
      action: () => {
        window?.positionNewSpanVert?.();
      },
      secondaryAction: null,
      cancelAction: () => {
        window?.cancelPositionNewSpanVert?.();
      },
      icon: partialVertical,
      tooltip: tooltips.partialVerticalDivider,
      disabledToolTooltip,
    },
    {
      disabled: disableAllTools || false,
      name: "Full Horizontal Divider",
      id: "full-horizontal-divider",
      action: () => {
        window?.positionNewFullHoriz?.();
      },
      secondaryAction: null,
      cancelAction: () => {
        window?.cancelPositionNewFullHoriz?.();
      },
      icon: fullHorizontal,
      tooltip: tooltips.fullHorizontalDivider,
      disabledToolTooltip,
    },
    {
      disabled: disableAllTools || false,
      name: "Partial Horizontal Divider",
      id: "partial-horizontal-divider",
      action: () => {
        window?.positionNewSpanHoriz?.();
      },
      secondaryAction: null,
      cancelAction: () => {
        window?.cancelPositionNewSpanHoriz?.();
      },
      icon: partialHorizontal,
      tooltip: tooltips.partialHorizontalDivider,
      disabledToolTooltip,
    },
  ];
  const spacingTools = [
    {
      disabled: disableAllTools || false,
      name: "Space Evenly",
      id: "space-evenly",
      action: () => {
        window?.spaceDividerSelect?.();
      },
      secondaryAction: () => {
        window?.finishSpaceDividerSelect?.();
      },
      cancelAction: () => {
        window?.cancelSpaceDividerSelect?.();
      },
      icon: spaceEvenly,
      tooltip: tooltips.spaceEvenly,
      disabledToolTooltip,
    },
  ];
  const moduleTools = [
    {
      disabled: disableAllTools || false,
      name: "Knife Block",
      id: "knife-block",
      action: () => {
        setToolActive(null);
        handleSetGlobalModal(
          <div className="common-modal">
            <div className="common-modal__content content">
              <h2>Option</h2>
              <p>
                Do you want to add a block for small knives or large knives?
              </p>
              <p>
                Small Knives - Fits an area that is from 7” to 12”. Minimum
                width is 4”.
              </p>
              <p>
                Large Knives - Fits an area that is more than 12” deep. Minimum
                width is 4”.
              </p>
              <div className="is-flex is-align-items-center">
                <button
                  className="button is-success"
                  onClick={() => {
                    window?.addKnifeblockSelect?.();
                    setToolActive({ id: "knife-block" });
                    handleSetGlobalModal(null);
                  }}
                >
                  Small Knives
                </button>
                <button
                  className="ml-4 button is-success"
                  onClick={() => {
                    window?.addLargeKnifeblockSelect?.();
                    setToolActive({ id: "knife-block" });
                    handleSetGlobalModal(null);
                  }}
                >
                  Large Knives
                </button>
              </div>
            </div>
          </div>,
          { customCloseCallBack: () => setToolActive(null) }
        );
      },
      secondaryAction: null,
      cancelAction: () => {
        window?.cancelAddKnifeblockSelect?.();
      },
      icon: knifeBlock,
      tooltip: tooltips.addKnifeBlock,
      disabledToolTooltip,
    },
    {
      disabled: disableAllTools || false,
      name: "Remove Knive Block",
      id: "remove-knife-block",
      action: () => {
        window?.removeKnifeblockSelect?.();
      },
      secondaryAction: null,
      cancelAction: () => {
        window?.cancelRemoveKnifeblockSelect?.();
      },
      icon: removeKnifeBlock,
      tooltip: tooltips.removeKnifeBlock,
      disabledToolTooltip,
    },
    {
      disabled: disableAllTools || false,
      name: "Spice Rack",
      id: "spice-rack",
      action: () => {
        window?.addSpicerackSelect?.();
      },
      secondaryAction: null,
      cancelAction: () => {
        window?.cancelAddSpicerackSelect?.();
      },
      icon: spiceRack,
      tooltip: tooltips.addSpiceRack,
      disabledToolTooltip,
    },
    {
      disabled: disableAllTools || false,
      name: "Remove Spice Rack",
      id: "remove-spice-rack",
      action: () => {
        window?.removeSpicerackSelect?.();
      },
      secondaryAction: null,
      cancelAction: () => {
        window?.cancelRemoveSpicerackSelect?.();
      },
      icon: removeSpiceRack,
      tooltip: tooltips.removeSpiceRack,
      disabledToolTooltip,
    },
  ];
  const cutOutTools = [
    {
      disabled: disableAllTools || false,
      name: "Divider Cutout",
      id: "divider-cutout",
      action: () => {
        window?.addCutawaySelect?.();
      },
      secondaryAction: null,
      cancelAction: () => {
        window?.cancelAddCutawaySelect?.();
      },
      icon: dividerCutout,
      tooltip: tooltips.dividerCutout,
      disabledToolTooltip,
    },
  ];
  const removeTools = [
    {
      disabled: disableAllTools || false,
      name: "Remove Cutout",
      id: "remove-cutout",
      action: () => {
        window?.removeCutawaySelect?.();
      },
      secondaryAction: null,
      cancelAction: () => {
        window?.cancelRemoveCutawaySelect?.();
      },
      icon: removeCutout,
      tooltip: tooltips.removeCutout,
      disabledToolTooltip,
    },
    {
      disabled: disableAllTools || false,
      name: "Delete Divider",
      id: "remove-divider",
      action: () => {
        window?.deleteDividerSelect?.();
      },
      secondaryAction: null,
      cancelAction: () => {
        window?.cancelDeleteDividerSelect?.();
      },
      icon: removeDivider,
      tooltip: tooltips.removeDivider,
      disabledToolTooltip,
    },
    {
      disabled: disableAllTools || false,
      name: "Delete All",
      id: "delete-all",
      action: () => {
        handleSetGlobalModal(
          <div className="common-modal">
            <div className="common-modal__content content">
              <h2>Are you sure?</h2>
              <p>All dividers will be removed from the current design.</p>
              <div className="is-flex is-align-items-center">
                <button
                  className="button is-danger"
                  onClick={() => handleSetGlobalModal(null)}
                >
                  Cancel
                </button>
                <button
                  className="ml-4 button is-success"
                  onClick={() => {
                    window?.deleteAll?.();
                    handleSetGlobalModal(null);
                    setTimeout(() => triggerPriceUpdate(), 50);
                  }}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>,
          null
        );
      },
      secondaryAction: null,
      cancelAction: null,
      icon: deleteAll,
      tooltip: tooltips.deleteAll,
      disabledToolTooltip,
    },
  ];

  useEffect(() => {
    const handleValidClick = () => {
      setToolActive(null);
    };
    if (validToolClickRef.current)
      validToolClickRef.current.addEventListener("click", handleValidClick);

    return () => {
      if (validToolClickRef.current)
        validToolClickRef.current.removeEventListener(
          "click",
          handleValidClick
        );
    };
  }, [validToolClickRef.current]);

  const labelStyle = {
    color: readableColor(variables.menuBgColor),
  };

  const Tool = ({ tool }) => (
    <>
      <button
        className={`reset-button toolbar--switch ${
          toolActive && toolActive.id === tool.id ? "active" : ""
        } ${toolActive && toolActive.id !== tool.id ? "not-clickable" : ""}`}
        id={tool.id}
        onClick={() => {
          if (!toolActive) {
            setToolActive(tool);
            tool.action();
            if (!tool.cancelAction) setToolActive(null);
          }
        }}
        style={labelStyle}
        disabled={tool.disabled}
        data-tip
        data-for={`${tool.id}-tip`}
      >
        <img
          className="toolbar--switch__icon"
          src={tool.icon}
          alt={tool.name + " icon"}
        />
        <span>{tool.name}</span>
        {toolActive && toolActive.id === tool.id && tool.secondaryAction && (
          <span
            className="toolbar--switch__finish-action"
            role="button"
            onClick={() => {
              setToolActive(null);
              tool.secondaryAction();
            }}
          >
            Apply
          </span>
        )}
        {toolActive && toolActive.id === tool.id && tool.cancelAction && (
          <span
            className="toolbar--switch__cancel-action"
            role="button"
            onClick={() => {
              setToolActive(null);
              tool.cancelAction();
            }}
          >
            Cancel
          </span>
        )}
      </button>
      {showTooltips && (
        <ReactTooltip
          id={`${tool.id}-tip`}
          place="right"
          effect="solid"
          className="tooltip"
        >
          {!toolActive
            ? tool.tooltip
            : toolActive.id !== tool.id
            ? tool.disabledToolTooltip
            : tool.tooltip}
        </ReactTooltip>
      )}
    </>
  );

  return (
    <div>
      <div className="toolbar">
        <button
          id="validToolClick"
          className="is-hidden"
          ref={validToolClickRef}
        ></button>
        <p className="toolbar--title title is-size-6" style={labelStyle}>
          Toolbar
        </p>
        <div id="dividerTools">
          {dividerTools.map((tool) => (
            <div key={tool.name}>
              <Tool tool={tool}></Tool>
            </div>
          ))}
        </div>
        <div id="spacingTools">
          {spacingTools.map((tool) => (
            <div key={tool.name}>
              <Tool tool={tool}></Tool>
            </div>
          ))}
        </div>
        <div id="moduleTools">
          {moduleTools.map((tool) => (
            <div key={tool.name}>
              <Tool tool={tool}></Tool>
            </div>
          ))}
        </div>
        <div id="cutOutTools">
          {cutOutTools.map((tool) => (
            <div key={tool.name}>
              <Tool tool={tool}></Tool>
            </div>
          ))}
        </div>
        <div id="removeTools">
          {removeTools.map((tool) => (
            <div key={tool.name}>
              <Tool tool={tool}></Tool>
            </div>
          ))}
        </div>
      </div>
      <hr className="horizontal"></hr>
    </div>
  );
};

export default Toolbar;
